import {Component, OnInit} from "@angular/core";
import {MultiCrudDataSource} from "../../table-datasouces/multi-crud.datasource";
import {toDateTimeStringNoSeconds} from "../../providers/app-date-adapter";
import {ContentRowField} from "../../shared/content-row/content-row.component";
import {WhiteListedBankAccountsService} from "../services/white-listed-bank-accounts.service";
import {WhiteListedBankAccount, WhiteListType} from "../../dto/trustPayTransaction";

@Component({
  selector: 'app-white-listed-sender-accounts',
  templateUrl: './white-listed-sender-accounts.component.html',
  styleUrls: ['./white-listed-sender-accounts.component.css']
})
export class WhiteListedSenderAccountsComponent implements OnInit {
  constructor(
    private whiteListedSenderAccountsService: WhiteListedBankAccountsService,
  ) { }

  ngOnInit(): void {
  }


  dataSource = new MultiCrudDataSource(this.whiteListedSenderAccountsService);
  columns = [

    {
      columnDef: 'date',
      header: 'Date',
      cell: row => `${toDateTimeStringNoSeconds(row.createdDate) || ''}`
    },
    {columnDef: 'name', header: 'Name', cell: row => `${row.senderAccountName}`},
    {columnDef: 'type', header: 'Type', cell: row => {
        if ( row.type == WhiteListType.Global) return "Global";
        if ( row.type == WhiteListType.Personal) return "Personal";
        return "-";
      }},
    {columnDef: 'account', header: 'Account', cell: row => `${row.senderAccountNumber}`},
    {columnDef: 'customer', header: 'Customer', cell: row => row.customer ? `${row.customer.firstName} ${row.customer.lastName}` : ""},
    {columnDef: 'user', header: 'Creator', cell: row => `${row.user?.email}`},

    //{columnDef: 'amount', header: 'Amount', cell: row => `${row.amount}`},
    //{columnDef: 'paidAmount', header: 'Paid Amount', cell: row => `${row.paidAmount}`},


  ] as ContentRowField<WhiteListedBankAccount>[];
  customActions: any[] = [];
  getRowClass = (item: WhiteListedBankAccount): string => '';
  getViewLink = (item: WhiteListedBankAccount): string => '/loads/white-listed-senders/' + item.id;
  getEditLink = (item: WhiteListedBankAccount): string => '/loads/white-listed-senders/' + item.id;


  editEnabled() {
    return false;
  }

  deleteEnabled() {
    return true;
  }
}
